import React from 'react'
import { Pagination } from 'antd'

import {
    DayBlock,
    DayTitle,
    EmptyBox,
    ErrorBox,
    LessonList,
    Loading,
    ScheduleArea,
} from '../../../components/scharedStyles/style'
import { formatScheduleDate } from '../utils/formatScheduleDate'
import { getLesson } from '../utils/lessonHelpers'
import ScheduleLessonCard from '../ScheduleLessonCard'
import { PaginationWrap } from './style'
import { useScheduleList } from './useScheduleList'

const ScheduleList = () => {
    const {
        viewMode,
        entries,
        loadingSchedule,
        errorMessage,
        totalItems,
        currentPage,
        pageSize,
        changePage,
        changePageSize,
    } = useScheduleList()

    return (
        <ScheduleArea style={{ width: '100%' }}>
            {errorMessage && <ErrorBox>{errorMessage}</ErrorBox>}

            {loadingSchedule ? (
                <Loading>Загрузка расписания...</Loading>
            ) : entries.length === 0 ? (
                <EmptyBox>Нет данных для отображения</EmptyBox>
            ) : (
                <>
                    {entries.map(([date, lessons]) => (
                        <DayBlock key={date}>
                            <DayTitle>{formatScheduleDate(date)}</DayTitle>
                            <LessonList>
                                {lessons.map((item, index) => {
                                    const lesson = getLesson(item)

                                    return (
                                        <ScheduleLessonCard
                                            key={lesson?.class_id || item?.class_id || index}
                                            item={item}
                                            index={index}
                                            viewMode={viewMode}
                                        />
                                    )
                                })}
                            </LessonList>
                        </DayBlock>
                    ))}

                    {totalItems > 0 && (
                        <PaginationWrap>
                            <Pagination
                                current={currentPage}
                                pageSize={pageSize}
                                total={totalItems}
                                onChange={changePage}
                                onShowSizeChange={changePageSize}
                            />
                        </PaginationWrap>
                    )}
                </>
            )}
        </ScheduleArea>
    )
}

export default ScheduleList
